import * as React from "react";
import { useEffect, useState } from "react";
import { HeaderSearchResults } from "../HeaderSearchResults";

export function TabbedLayout({
  settings,
  query,
  productsTotal,
  articlesTotal,
  handleCategoryClick,
  selectedCategory,
  isMobile,
  articles,
  products,
  showSeeAllProductsAtBottom,
}) {
  const showNavigationTabs = true;

  return (
    <>
      <div className={"header-search__tabbed flex justify-between items-center"}>
        <div className="flex w-full lg:w-auto justify-between">
          <h2 className="bfb font-semibold">
            Product Results ( {productsTotal} )
          </h2>
          <div
            className="lg:hidden w-[24px] h-[24px] border-none px-[24px] text-[20px]"
            x-on:click="$store.global.toggleSearch()"
          >
            <span className="sr-only">Close</span>
            <i className="icon icon-x-thin"></i>
          </div>
        </div>
        <div className="hidden lg:flex gap-x-[8px]">
          <a href={`/search?q=${query}&type=product`} className="b3 button-text flex items-center gap-2">
            <span className="hover:underline">Show All Product Results</span>
            <i className={`icon icon-ur-arrow text-[19px]`}></i>
          </a>
        </div>
      </div>

      {showNavigationTabs && (
        <div className="border-b border-gray-200 hidden lg:block">
          <nav className="flex space-x-4">
            <div
              className={`bc py-[14px] px-6 cursor-pointer ${selectedCategory === "products" ? "selected text-black border-b border-[#54565A]" : "text-[#99A8B2]"} ${productsTotal > 0 ? "block" : "hidden"}`}
              onClick={() => handleCategoryClick("products")}
            >
              PRODUCTS ( {productsTotal} )
            </div>
            <div
              className={`bc py-[14px] px-6 cursor-pointer ${selectedCategory === "articles" ? "selected text-black border-b border-[#54565A]" : "text-[#99A8B2]"} ${articlesTotal > 0 ? "block" : "hidden"}`}
              onClick={() => handleCategoryClick("articles")}
            >
              ARTICLES ( {articles.length} )
            </div>
          </nav>
        </div>
      )}

      {selectedCategory === "products" && products && (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto lg:pt-6">
            <HeaderSearchResults
              settings={settings}
              results={products}
              type={"products"}
            />
          </div>

          {isMobile && selectedCategory === "products" && products && (
            <div className="lg:flex gap-x-[8px] flex justify-center">
              <a
                href={`/search?q=${query}`}
                className="b3 button-text flex items-center gap-2"
              >
                <span className="hover:underline">Show All Product Results</span>
                <i className={`icon icon-ur-arrow text-[19px]`}></i>
              </a>
            </div>
          )}
        </>
      )}
      {selectedCategory === "articles" && articles && (
        <div>
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-x-2 lg:gap-x-5 gap-y-4 lg:gap-y-10 lg:overflow-y-auto pb-4 lg:pt-4">
            <HeaderSearchResults
              settings={settings}
              results={articles}
              type={"articles"}
            />
          </div>
        </div>
      )}
      {!isMobile &&
        showSeeAllProductsAtBottom &&
        selectedCategory === "products" &&
        products && (
          <div className="text-center mt-4">
            <a
              href={`/search?q=${query}`}
              className={"button btn-outline hover:no-underline"}
            >
              SEE ALL PRODUCTS ({productsTotal})
            </a>
          </div>
        )}
    </>
  );
}
